// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VCharts from 'v-charts'
import echarts from 'echarts'
import App from './App'
import router from './router'
import axios from 'axios'
import store from './vuex/store'
import Vant from 'vant';
// import '@vant/touch-emulator';
import 'vant/lib/index.css';
import filters from './filter'
import request from "@/axios/token";

Vue.filter('moneyP',filters)
Vue.use(Vant);
Vue.use(VCharts);
Vue.use(request);
Vue.config.productionTip = false
Vue.prototype.$http = axios;
Vue.prototype.$echarts = echarts
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js